import React from 'react';

import { Tooltip } from '../../../common/Tooltip';

interface ProgressTooltipProps {
  children: React.ReactNode;
  progressAchieved: number;
  previousProgress: number;
  totalProgress: number;
}

export function ProgressTooltip({
  children,
  progressAchieved,
  previousProgress,
  totalProgress,
}: ProgressTooltipProps): JSX.Element {
  const content = (
    <div className="space-y-2 min-w-[240px]">
      <div className="flex justify-between gap-8">
        <span className="text-gray-500 whitespace-nowrap">
          Progress Achieved:
        </span>
        <span
          className={progressAchieved > 0 ? 'text-green-600' : 'text-gray-900'}
        >
          {progressAchieved > 0 ? '+' : ''}
          {progressAchieved}%
        </span>
      </div>
      <div className="flex justify-between gap-8">
        <span className="text-gray-500">Previous Progress:</span>
        <span className="text-gray-900">{previousProgress}%</span>
      </div>
      <div className="flex justify-between gap-8">
        <span className="text-gray-500">Total Progress:</span>
        <span className="text-gray-900">{totalProgress}%</span>
      </div>
    </div>
  );

  return <Tooltip content={content}>{children}</Tooltip>;
}
